const MuiContainer = {
  styleOverrides: {
    root: ({ theme }) => ({
      paddingRight: "8px",
      paddingLeft: "8px",

      [theme.breakpoints.up("md")]: {
        paddingRight: "16px !important",
        paddingLeft: "16px !important",
      },
    }),
  },
};

export default MuiContainer;
